import { useState, type FormEvent } from "react";
import { useAuth } from "../lib/auth";
import { friendlyError } from "../lib/errors";

export default function PasswordCard() {
  const { setPassword } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [savedAt, setSavedAt] = useState<number | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (pw.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (pw !== pw2) {
      setError("Passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await setPassword(pw);
      setSavedAt(Date.now());
      setPw("");
      setPw2("");
    } catch (err) {
      setError(friendlyError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="p-4 rounded-2xl bg-slate-900 border border-slate-800 space-y-3">
      <div>
        <div className="text-xs text-slate-400 uppercase tracking-wide">Password</div>
        <div className="text-xs text-slate-500 mt-0.5">
          Set or change your account password. If you originally signed in via email code, set one here so you can sign in faster next time.
        </div>
      </div>

      <form onSubmit={submit} className="space-y-2">
        <input
          type="password"
          autoComplete="new-password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="New password (min 6)"
          className="w-full bg-slate-800 border border-slate-700 rounded px-3 py-2 text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-emerald-500"
        />
        <input
          type="password"
          autoComplete="new-password"
          value={pw2}
          onChange={(e) => setPw2(e.target.value)}
          placeholder="Confirm password"
          className="w-full bg-slate-800 border border-slate-700 rounded px-3 py-2 text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-emerald-500"
        />
        <button
          type="submit"
          disabled={busy || !pw}
          className="w-full py-2 rounded bg-emerald-500 text-slate-950 text-sm font-semibold disabled:opacity-50"
        >
          {busy ? "Saving…" : "Set password"}
        </button>
        {error && (
          <div className="p-2 rounded bg-red-950 border border-red-800 text-red-200 text-xs">
            {error}
          </div>
        )}
        {savedAt !== null && (
          <div className="p-2 rounded bg-emerald-950 border border-emerald-800 text-emerald-100 text-xs">
            Password updated.
          </div>
        )}
      </form>
    </section>
  );
}
